{
  "charts": {
    "dateLabel": "Data: {{date}}",
    "completion": {
      "title": "Taxa de Conclusão por Curso",
      "description": "Cursos com melhor performance",
      "overallAverage": "Média Geral",
      "levels": {
        "excellent": "Excelente",
        "good": "Boa",
        "fair": "Regular",
        "low": "Baixa"
      },
      "tooltipLabel": "Taxa de Conclusão",
      "tooltipDetail": "{{completed}} de {{total}} matrículas concluídas",
      "legend": {
        "excellent": "Excelente (≥80%)",
        "good": "Boa (60-79%)",
        "fair": "Regular (40-59%)",
        "low": "Baixa (<40%)"
      }
    },
    "engagement": {
      "title": "Métricas de Engajamento",
      "description_one": "Atividade diária do último {{count}} dia",
      "description_zero": "Atividade diária dos últimos {{count}} dias",
      "description_other": "Atividade diária dos últimos {{count}} dias",
      "uniqueUsers": "Usuários Únicos",
      "sessions": "Sessões",
      "pageViews": "Visualizações"
    },
    "retention": {
      "loadingTitle": "Análise de Retenção",
      "title": "Análise de Retenção de Usuários",
      "description": "Taxa de retenção por coorte nos últimos 10 dias",
      "newUsers": "Novos Usuários",
      "day": "Dia {{day}}",
      "retentionDay": "Retenção Dia {{day}}"
    }
  },
  "tabs": {
    "overview": "Visão Geral",
    "students": "Alunos",
    "lessons": "Aulas",
    "payments": "Pagamentos",
    "courses": "Cursos"
  },
  "paymentStatus": {
    "paid": "Pago",
    "refunded": "Reembolsado",
    "chargeback": "Chargeback",
    "pending": "Pendente",
    "cancelled": "Cancelado"
  },
  "paymentMethods": {
    "creditCard": "Cartão",
    "debitCard": "Débito",
    "pix": "PIX",
    "boleto": "Boleto",
    "bankTransfer": "Transf."
  },
  "page": {
    "title": "Dashboard",
    "subtitle": "Visão completa da plataforma",
    "loading": "Carregando dashboard...",
    "loadError": "Erro ao carregar dados do dashboard",
    "realTime": "Tempo real"
  },
  "stats": {
    "totalRevenue": "Receita Total",
    "monthlyRevenue": "Receita Mensal",
    "averageTicket": "Ticket Médio",
    "averageTicketSub": "Valor médio por venda",
    "users": "Usuários",
    "activeCourses": "Cursos Ativos",
    "completion": "Conclusão de aulas",
    "refund": "Reembolso",
    "chargeback": "Chargeback",
    "refundChargeback": "Reembolso / Chargeback",
    "chargebackSub": "Chargeback: {{rate}}%",
    "salesCount_one": "{{count}} venda",
    "salesCount_zero": "{{count}} vendas",
    "salesCount_other": "{{count}} vendas",
    "salesThisMonth_one": "{{count}} venda este mês",
    "salesThisMonth_zero": "{{count}} vendas este mês",
    "salesThisMonth_other": "{{count}} vendas este mês",
    "enrollmentsCount_one": "{{count}} matrícula",
    "enrollmentsCount_zero": "{{count}} matrículas",
    "enrollmentsCount_other": "{{count}} matrículas"
  },
  "series": {
    "revenue": "Receita",
    "refunds": "Reembolsos",
    "sales": "Vendas",
    "enrollments": "Matrículas",
    "completions": "Conclusões",
    "amount": "Valor"
  },
  "overview": {
    "monthlyRevenueTitle": "Receita Mensal (12 meses)",
    "salesPerMonth": "Vendas por Mês",
    "enrollmentsVsCompletions": "Matrículas vs Conclusões",
    "coursesByCategory": "Cursos por Categoria",
    "topCourses": "Top Cursos",
    "studentsCount_one": "{{count}} aluno",
    "studentsCount_zero": "{{count}} alunos",
    "studentsCount_other": "{{count}} alunos",
    "noCourses": "Nenhum curso encontrado",
    "noCategories": "Nenhuma categoria"
  },
  "payments": {
    "methods": "Meios de Pagamento",
    "noSalesRecorded": "Nenhuma venda registrada",
    "recentSales": "Vendas Recentes",
    "noSalesYet": "Nenhuma venda ainda",
    "noSalesYetDescription": "As vendas aparecerão aqui quando forem processadas",
    "revenueAndSalesTitle": "Receita e Vendas (12 meses)"
  },
  "students": {
    "unavailable": "Dados de alunos não disponíveis",
    "enrollmentStatus": {
      "active": "Ativas",
      "expired": "Expiradas",
      "cancelled": "Canceladas"
    },
    "total": "Total de Alunos",
    "newThisMonth_one": "{{count}} novo este mês",
    "newThisMonth_zero": "{{count}} novos este mês",
    "newThisMonth_other": "{{count}} novos este mês",
    "newToday": "Novos Hoje",
    "thisWeek_one": "{{count}} esta semana",
    "thisWeek_zero": "{{count}} esta semana",
    "thisWeek_other": "{{count}} esta semana",
    "dau": "Usuários Ativos (DAU)",
    "withEnrollments": "Com Matrículas",
    "ofTotal": "{{rate}}% do total",
    "verifiedEmails": "Emails Verificados",
    "withCompletions": "Com Conclusões",
    "completionRate": "Alunos com conclusão",
    "newPerDayTitle": "Novos Alunos por Dia (30 dias)",
    "newStudents": "Novos alunos",
    "enrollmentsByStatus": "Matrículas por Status",
    "noEnrollments": "Nenhuma matrícula registrada",
    "activeUsers": "Usuários Ativos",
    "activeToday": "Ativos Hoje",
    "activeTodaySub": "Usuários únicos nas últimas 24h",
    "activeWeek": "Ativos na Semana",
    "activeWeekSub": "Usuários únicos nos últimos 7 dias",
    "activeMonth": "Ativos no Mês",
    "activeMonthSub": "Usuários únicos nos últimos 30 dias",
    "engagement": "Engajamento (Ativos Hoje / Ativos no Mês)",
    "recentEnrollments": "Matrículas Recentes",
    "noRecentEnrollments": "Nenhuma matrícula recente"
  },
  "lessons": {
    "unavailable": "Dados de aulas não disponíveis",
    "total": "Total de Aulas",
    "started_one": "{{count}} iniciada",
    "started_zero": "{{count}} iniciadas",
    "started_other": "{{count}} iniciadas",
    "completed": "Aulas Concluídas",
    "completionRate": "{{rate}}% de conclusão",
    "watchedWeek": "Assistidas (Semana)",
    "thisMonth_one": "{{count}} este mês",
    "thisMonth_zero": "{{count}} este mês",
    "thisMonth_other": "{{count}} este mês",
    "averageProgress": "Progresso Médio",
    "sessions_one": "{{count}} sessão",
    "sessions_zero": "{{count}} sessões",
    "sessions_other": "{{count}} sessões",
    "activityTitle": "Atividade de Aulas por Dia (30 dias)",
    "watched": "Assistidas",
    "completedSeries": "Concluídas",
    "mostWatched": "Aulas Mais Assistidas",
    "views": "views",
    "completions": "completas",
    "noneWatched": "Nenhuma aula assistida",
    "recentCompleted": "Últimas Aulas Concluídas"
  },
  "courses": {
    "published": "Cursos Publicados",
    "inDevelopment_one": "{{count}} em desenvolvimento",
    "inDevelopment_zero": "{{count}} em desenvolvimento",
    "inDevelopment_other": "{{count}} em desenvolvimento",
    "totalEnrollments": "Total Matrículas",
    "completionRate": "Conclusão de cursos",
    "categories": "Categorias",
    "performance": "Performance por Curso",
    "modules_one": "{{count}} módulo",
    "modules_zero": "{{count}} módulos",
    "modules_other": "{{count}} módulos",
    "enrollments": "matrículas",
    "active": "ativas",
    "completed": "concluídas",
    "progress": "progresso",
    "completion": "conclusão",
    "noPublished": "Nenhum curso publicado",
    "categoryDistribution": "Distribuição por Categoria",
    "completionByCourse": "Taxa de Conclusão por Curso",
    "recentCompletions": "Últimas Conclusões de Curso"
  }
}
